import type { AiCostDimension } from '@Application/AiCosts/AiCostDimension';

export type SubjectDimension = Extract<AiCostDimension, 'facilities' | 'organizations' | 'users'>;

export type SubjectDimensionLabels = {
	readonly title: string;
	readonly column: string;
	readonly singular: string;
	readonly plural: string;
	/** Tells that a row can be opened; `null` for an axis whose rows lead nowhere. */
	readonly hint: string | null;
};

const subjectDimensionLabels: Readonly<Record<SubjectDimension, SubjectDimensionLabels>> = Object.freeze({
	facilities: {
		title: 'Coûts par agence',
		column: 'Agence',
		singular: 'agence',
		plural: 'agences',
		hint: 'Cliquez sur une agence pour voir le détail par utilisateur.',
	},
	organizations: {
		title: 'Coûts par structure',
		column: 'Structure',
		singular: 'structure',
		plural: 'structures',
		hint: 'Cliquez sur une structure pour voir ses agences.',
	},
	users: {
		title: 'Coûts par utilisateur',
		column: 'Utilisateur',
		singular: 'utilisateur',
		plural: 'utilisateurs',
		hint: null,
	},
});

export default subjectDimensionLabels;
